export const SERVICE_ERROR_MESSAGE = `Our bees seem to have gone foraging and we're dancing them back in as soon as possible`;
export const SERVICE_MAINTENANCE_MESSAGE =
    'We are currently doing some housekeeping on our apiary and will be back shortly';
export const SERVICE_MORE_INFO = 'For more information, contact us at';
